import Vue from "vue";
import Vuex from "vuex";
import getters from "@/store/getters";
import actions from "@/store/actions";
import mutations from "@/store/mutations";
import state from "@/store/state";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
});

store.watch(
  (state) => state.featureFlags,
  (newVal) => {
    store.commit(
      "SET_MINIMUM_CONTRACT_LENGTH",
      newVal.min_contract_length.value,
    );
  },
);
export default store;
